import {
  SET_ACCOUNTS
} from 'app/actions/types';

import {
  ME
} from 'shared/actions/types';

import {
  getAccounts as getAccountsSvc,
  getAccountLogoSignedUrl as getAccountLogoSignedUrlSvc,
  getAccountWatermarkSignedUrl as getAccountWatermarkSignedUrlSvc,
  acceptInviteLogin as acceptInviteLoginSvc
} from 'app/services/accounts';

import {
  uploadFile as uploadFileSvc
} from 'shared/services/FileService';

export const getAccounts = params => async dispatch => {
  let accounts = await getAccountsSvc(params);

  if (accounts) {
    dispatch({
      type: SET_ACCOUNTS,
      payload: accounts.params
    });
  }

  return accounts;
}

export const setAccountParams = params => async dispatch => {
  dispatch({
    type: SET_ACCOUNTS,
    payload: params
  });
}

export const uploadAccountLogo = (accountId, type, file) => async dispatch => {
  var signed = await getAccountLogoSignedUrlSvc(accountId, type);
  await uploadFileSvc(signed.url, file);
  return signed;
}

export const uploadAccountWatermark = (accountId, type, file) => async dispatch => {
  var signed = await getAccountWatermarkSignedUrlSvc(accountId, type);
  await uploadFileSvc(signed.url, file);
  return signed;
}

export const acceptInviteLogin = token => async dispatch => {
  let params = { token };
  let user = await acceptInviteLoginSvc(params);

  dispatch({
    type: ME,
    payload: user
  });

  return user;
}
